import state from "@/store/registration/state";
import getters from "@/store/registration/getters";
import mutations from "@/store/registration/mutations";
import * as actions from "@/store/registration/actions";

const registrationModule = {
	namespaced: true,
	getters,
	mutations,
	actions,
	state,
};

export default registrationModule;
